import Fetcher from 'middlewares/Fetcher';
import { DownloadResponse } from 'api/APIRest';
import { downloadBlobFile } from 'utils/downloadBlobFile';
import { IntermediaryConfigurationActionType } from './ActionTypes';
import {
  DownloadApiRequestTemplateAction,
  downloadApiRequestTemplateFailure,
  downloadApiRequestTemplateSuccess,
} from './ActionCreator';
import { ApiRequestTemplatesApi } from 'api/LoanOriginationSystem/ApiRequestTemplatesApi';

const DownloadApiRequestTemplateMiddleware = (api: ApiRequestTemplatesApi) =>
  Fetcher<DownloadResponse, DownloadApiRequestTemplateAction>(
    IntermediaryConfigurationActionType.DownloadApiRequestTemplate,
    downloadApiRequestTemplateSuccess,
    downloadApiRequestTemplateFailure,
    async (action) => {
      const response = await api.downloadIntermediaryApiRequestTemplate(action.payload.requestType);

      downloadBlobFile(response);

      return response;
    },
  );

export default DownloadApiRequestTemplateMiddleware;
